export const QUESTIONS = [
  {
    id: "q1",
    text: "Se l'AI automatizzasse il 90% dei tuoi task, avresti il coraggio di usare il tempo rimasto per guidare con visione, o sentiresti il bisogno di riempire subito l'agenda con nuove urgenze?",
    options: {
      A: "Farei ancora di più: il mio valore oggi è legato a quanto sono occupato.",
      B: "Cercherei di fermarmi, ma senza un metodo tornerei presto nel vortice operativo.",
      C: "Lo userei per l'orchestrazione strategica e la cura delle relazioni chiave.",
    },
  },
  {
    id: "q2",
    text: "Nelle tempeste aziendali, decidi per reazione all'urgenza o riesci a mantenere la calma per valutare scenari alternativi?",
    options: {
      A: "Reagisco all'istante: non c'è tempo per l'analisi quando tutto brucia.",
      B: "Cerco dati, ma spesso finisco sommerso da informazioni frammentate.",
      C: "Integro dati e intuizione per decidere con lucidità e coraggio.",
    },
  },
  {
    id: "q3",
    text: "Ti senti libero di guidare con la tua voce autentica o senti la necessità di aderire a un ruolo predefinito per proiettare l'autorevolezza che il contesto richiede?",
    options: {
      A: "Bado alla sostanza tecnica e preferisco mantenere un distacco professionale in linea con il business.",
      B: "Dipende dalle situazioni, a volte mi sento più me stesso altre volte sono costretto ad attenermi strettamente al ruolo.",
      C: "Uso la coerenza tra ciò che sono e ciò che faccio come leva strategica per generare fiducia e impatto.",
    },
  },
  {
    id: "q4",
    text: "Sei in grado di mappare scientificamente le Soft Skills (tue o del team) o ti basi solo sull'intuito e sui risultati tecnici immediati?",
    options: {
      A: "Guardo solo ai KPI tecnici e alla produttività visibile.",
      B: "Intuisco il valore nascosto delle persone, ma non ho strumenti per misurarlo.",
      C: "Alleno le \"Soft Skills Value\" come unico asset non automatizzabile.",
    },
  },
  {
    id: "q5",
    text: "Il World Economic Forum avverte che le competenze vanno resettate ogni 5 anni: sai come proteggere il valore professionale (tuo o del tuo team) dall'obsolescenza?",
    options: {
      A: "Mi affido all'esperienza accumulata: finora ha sempre funzionato.",
      B: "Seguo la formazione che desta il mio interesse, senza una roadmap chiara per il futuro.",
      C: "Ho un piano di Reskilling basato sui dati per anticipare il mercato.",
    },
  },
  {
    id: "q6",
    text: "In un mercato che chiede verità (e con la Direttiva UE sulla Pay Transparency ora in vigore), come garantisci che il valore delle persone sia riconosciuto equamente e senza bias?",
    options: {
      A: "Mi baso sulle consuetudini aziendali e sulla seniority, confidando nella correttezza dei processi storici.",
      B: "Percepisco disparità o gap (come il Gender Pay Gap), ma non so come tradurre il potenziale umano in evidenze oggettive.",
      C: "Utilizzo People Analytics per certificare il valore reale e neutralizzare i bias, rendendo la trasparenza un vantaggio competitivo.",
    },
  },
  {
    id: "q7",
    text: "Sulla base delle riflessioni fatte finora, in quale 'fotografia' ti riconosci maggiormente e quale passo senti più urgente per la tua evoluzione?",
    options: {
      A: "Sento di essere intrappolato nell'operatività e voglio riprendere il controllo della mia energia fisica e mentale.",
      B: "Sento di avere un grande potenziale ma mi mancano gli strumenti scientifici per mapparmi e agire con sicurezza.",
      C: "Sono pronto a guidare la trasformazione digitale garantendo equità di trattamento, trasparenza e mettendo l'umano al centro.",
    },
  },
];

export const RESULTS = {
  A: {
    title: "Il Leader Reattivo",
    subtitle: "La trappola del 'Fare'",
    body: "Questa fotografia ritrae un professionista solido tecnicamente, ma attualmente intrappolato in una modalità molto operativa. La tua energia è quasi interamente assorbita dalle urgenze e dal monitoraggio dei task operativi. Ti affidi molto all'esperienza passata e alla consuetudine, agendo spesso in uno stato di 'pilota automatico' che limita la tua visione strategica.",
    sections: [
      { label: "Il Rischio", text: "La mancanza di un piano di reskilling e la svalutazione delle soft skills possono rendere il tuo valore professionale vulnerabile ai cambiamenti rapidi del mercato." },
      { label: "La Sfida dell'Essere", text: "Il tuo primo passo è recuperare la Dimensione Fisica (Tempo) per smettere di 'fare di più' e iniziare a 'essere di più'." },
      { label: "Consiglio Strategico", text: "Per te è ideale l'Academy 'Oltre l'Algoritmo', per ispirare un cambio di paradigma e allenare le basi della leadership consapevole." },
    ],
  },
  B: {
    title: "Il Leader Intuitivo",
    subtitle: "Il Potenziale Inespresso",
    body: "Questa fotografia mostra un leader sensibile e consapevole del cambiamento, che però si sente bloccato dalla mancanza di strumenti o dal timore del giudizio. Percepisci chiaramente che esiste un valore intangibile e un potenziale inespresso, sia in te che nel tuo team, ma ti mancano le metodologie scientifiche per mapparlo e valorizzarlo. A volte indossi una 'maschera' di circostanza che drena la tua energia autentica.",
    sections: [
      { label: "Il Rischio", text: "L'incertezza e la 'sindrome dell'impostore' possono rallentare il tuo 'salto' verso l'innovazione, lasciandoti in una zona di attesa cauta." },
      { label: "La Sfida dell'Essere", text: "Devi fortificare la Dimensione Mentale ed Emozionale, trasformando l'intuizione in dati oggettivi e decisioni lucide." },
      { label: "Consiglio Strategico", text: "Il percorso ideale per te è l'Executive Advisory o il Coaching, per acquisire la 'bussola scientifica' necessaria a guidare con sicurezza." },
    ],
  },
  C: {
    title: "Il Leader Orchestratore",
    subtitle: "L'Essenza Strategica",
    body: "Questa fotografia rappresenta il profilo più allineato alla leadership del futuro, capace di integrare tecnologia e umanità. Sei un orchestratore che usa l'AI e i dati come leve per liberare tempo da investire in visione e relazioni di valore. La tua leadership è 'Purpose Driven': guidi con un senso di missione chiaro e sai difendere il valore di unicità che porti sul mercato.",
    sections: [
      { label: "Il Punto di Forza", text: "Hai il coraggio di osare e di considerare l'errore come un investimento nell'apprendimento accelerato." },
      { label: "La Sfida dell'Essere", text: "Mantenere l'equilibrio tra tutte le dimensioni per garantire che la tua forza sia sostenibile e ispiratrice nel lungo periodo." },
      { label: "Consiglio Strategico", text: "Sei pronto per certificare la tua equità organizzativa e massimizzare il ritorno sul capitale umano tramite i People Analytics?" },
    ],
  },
};

export const COUNTRY_CODES = [
  { code: "+39", label: "Italia (+39)" },
  { code: "+41", label: "Svizzera (+41)" },
  { code: "+33", label: "Francia (+33)" },
  { code: "+49", label: "Germania (+49)" },
  { code: "+34", label: "Spagna (+34)" },
  { code: "+44", label: "Regno Unito (+44)" },
  { code: "+1", label: "USA / Canada (+1)" },
  { code: "+351", label: "Portogallo (+351)" },
  { code: "+31", label: "Paesi Bassi (+31)" },
  { code: "+32", label: "Belgio (+32)" },
  { code: "+43", label: "Austria (+43)" },
  { code: "+353", label: "Irlanda (+353)" },
  { code: "+352", label: "Lussemburgo (+352)" },
  { code: "+30", label: "Grecia (+30)" },
  { code: "+45", label: "Danimarca (+45)" },
  { code: "+46", label: "Svezia (+46)" },
  { code: "+47", label: "Norvegia (+47)" },
  { code: "+358", label: "Finlandia (+358)" },
  { code: "+48", label: "Polonia (+48)" },
  { code: "+40", label: "Romania (+40)" },
  { code: "+380", label: "Ucraina (+380)" },
  { code: "+971", label: "Emirati Arabi (+971)" },
  { code: "+61", label: "Australia (+61)" },
  { code: "+55", label: "Brasile (+55)" },
];
